import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import logo from '../assets/images/sds-logo.svg';
import { Link, useLocation } from "react-router-dom";


import Offcanvas from 'react-bootstrap/Offcanvas';
import { useEffect, useState } from "react";
import { Container, Row, Tab, Col } from 'react-bootstrap';
// New package button
import { Button } from '@veeyaainnovatives/button';

import useCustom from "../hooks/useCustom";
import EnrollModal from '../components/enroll-modal';
import NavDropdown from 'react-bootstrap/NavDropdown';
import contactData from '../assets/static_datas/contact.json';

import { useNavigate } from 'react-router-dom';
// New package megamenu
import { MegaMenu } from '@veeyaainnovatives/megamenu';
import '@veeyaainnovatives/megamenu/styles.css';

const Menu = () => {


  const navigate = useNavigate();
  const [showSideMenu, setShowSideMenu] = useState(false);
  const [visibility, setVisibility] = useState(false);

  const handleSideMenuClose = () => {
    setVisibility("");
    setShowSideMenu(false);
  }
  const handleSideMenuShow = () => {
    setVisibility("visibility-hidden");
    setShowSideMenu(true);
  }

  const [navClass, setNavClass] = useState("");

  useEffect(() => {

    scrollDirection();
    window.addEventListener('scroll', pop);

    return () => window.removeEventListener('scroll', pop);
  }, []);


  const scrollDirection = () => {
    let prevScrollpos = window.pageYOffset;
    window.onscroll = function () {
      let currentScrollPos = window.pageYOffset;
      if (prevScrollpos > currentScrollPos) {
        // Scrolling up
        setNavClass("fixed-top");
      } else {
        // Scrolling down');
        setNavClass("bg-transparent");
      }
      prevScrollpos = currentScrollPos;
    }
  }

  const pop = () => {
    if (window.scrollY > 0) {
      // setNavClass("fixed-top");
    } else {
      setNavClass("bg-transparent");
    }

  }

  const {
    show,
    handleShow,
    handleClose,
    fetchServices,
    servicesData,
    servicesLoading
  } = useCustom();


  //assigning location variable
  const location = useLocation();

  //destructuring pathname from location
  const { pathname } = location;

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");

  const handleCall = () => {
    // Get phone number from contact data
    const phoneNumber = contactData.phone.replace(/\s/g, '').replace(/-/g, '');
    window.location.href = `tel:${phoneNumber}`;
  };

  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  // Close dropdown on scroll
  useEffect(() => {
    const handleScroll = () => setOpen(false);
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // Fetch services from API
  useEffect(() => {
    fetchServices();
  }, []);


  return (
    <div className={`position-relative hidden-in-pdf-view ${visibility}`}>
      {['xl'].map((expand) => (
        <Navbar key={expand} expand={expand} className={`bg-body-tertiary custom-navbar ${navClass}`} data-bs-theme="dark" bg="dark" onToggle={handleSideMenuShow} >
          <Container>
            <Navbar.Brand href="/" className="d-flex align-items-center justify-content-center">
              <img src={logo} className="App-logo" alt="logo" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`}  >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 14 13" fill="none" >
                <path d="M1 0.5H13M5.5 6.5H13M1 12.5H13" stroke="#F8F8F8" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Navbar.Toggle>
            <Navbar.Offcanvas
              show={showSideMenu} onHide={handleSideMenuClose}
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  <img src={logo} className="App-logo" alt="logo" />
                </Offcanvas.Title>

                <Button 
                  variant="text"
                  className="ms-auto"
                  onClick={handleSideMenuClose}
                  backgroundColor="transparent"
                  color="#F8F8F8"
                  hoverBackgroundColor="transparent"
                  padding="0"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M1.5 14.7168L14.935 1.28177" stroke="#F8F8F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M14.5 14.7178L1.06497 1.28274" stroke="#F8F8F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </Button>
              </Offcanvas.Header>
              <Offcanvas.Body>


                <Nav className="ms-auto">
                  <Link className={splitLocation[1] === "" || splitLocation[1] === "home" ? "active nav-link" : "nav-link"} to="/" onClick={handleSideMenuClose} >Home</Link>
                  <Link className={splitLocation[1] === "about-us" ? "active nav-link" : "nav-link"} to="/about-us" onClick={handleSideMenuClose}>About Us</Link>
                  <Link className={splitLocation[1] === "our-pricing" ? "active nav-link" : "nav-link"} to="/our-pricing" onClick={handleSideMenuClose}>Our Pricing</Link>

                  {/* Mega DropDown Start */}



                  {/* Services Menu - Using @veeyaainnovatives/megamenu */}
                  {!isMobile ? (
                    <NavDropdown
                      title="Services"
                      id="services-mega-dropdown"
                      className="mega-dropdown"
                      autoClose="outside"
                      show={open}
                      onToggle={(next) => setOpen(next)}
                    >
                      <MegaMenu
                        services={servicesData}
                        loading={servicesLoading}
                        backgroundColor="#ffffff"
                        asDropdownContent={true}
                        onMenuClose={() => setOpen(false)}
                        onServiceClick={(subService) => {
                          navigate(`/services/${subService.slug}`);
                          setOpen(false);
                        }}
                        onViewAllClick={() => {
                          navigate('/services');
                          setOpen(false);
                        }}
                      />
                    </NavDropdown>
                  ) : (
                    <NavDropdown title="Services" id="mobile-services-dropdown">
                      {servicesLoading ? (
                        <NavDropdown.Item disabled>Loading...</NavDropdown.Item>
                      ) : servicesData.length === 0 ? (
                        <NavDropdown.Item disabled>No services available</NavDropdown.Item>
                      ) : (
                        servicesData.map((service) => (
                          <NavDropdown.Item
                            key={service.id}
                            as={Link}
                            to={`/services`}
                            onClick={handleSideMenuClose}
                          >
                            {service.text}
                          </NavDropdown.Item>
                        ))
                      )}
                    </NavDropdown>
                  )}

                  {/* Mega DropDown Ends */}

                  <Link className={splitLocation[1] === "blogs" ? "active nav-link" : "nav-link"} to="/blogs" onClick={handleSideMenuClose}>Blogs</Link>

                  {/* <Link className={splitLocation[1] === "faq" ? "active nav-link" : "nav-link"} to="/faq" onClick={handleSideMenuClose}>FAQ's</Link> */}
                  <Link className={splitLocation[1] === "portfolio" ? "active nav-link" : "nav-link"} to="/portfolio" onClick={handleSideMenuClose}>Portfolio</Link>
                  <Link className={splitLocation[1] === "contact-us" ? "active nav-link" : "nav-link"} to="/contact-us" onClick={handleSideMenuClose}>Contact Us</Link>
                  <Link className="nav-link enroll-btn me-0" onClick={handleShow}>Get Quote</Link>
                </Nav>

              </Offcanvas.Body>
            </Navbar.Offcanvas>

          </Container>

        </Navbar>
      ))}


      {/* Fixed split action footer for Mobile View (Call Now / Get Free Estimate) */}
      <div className="fixed-footer-wrap">
        <button
          type="button"
          className="call-now-btn"
          onClick={handleCall}
        >
          <span className="fa fa-phone me-2" /> Call Now
        </button>

        <button
          type="button"
          onClick={handleShow}
          className="free-estimate-btn"
        >
          <span className="fa fa-calendar-check me-2" /> Get Free Estimate
        </button>
      </div>


      <EnrollModal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      />

    </div>
  );
}

export default Menu;